<div class="tree-item" *ngIf="item">
  <div class="tree-item__icon">
    <mat-icon *ngIf="!item.image" svgIcon="{{ item.icon }}">{{ item.icon }}</mat-icon>
    <img *ngIf="item.image" [src]="item.image" [alt]="item.text" appImageLoad />
  </div>
  <div class="tree-item__text">
    <span class="text-main">
      <span class="text-main__text" [class.archived]="item.archived">{{ item.text }}</span>
      <span class="text-main__dot" *ngIf="item.description || item.archived">&nbsp;•&nbsp;</span>
      <span class="text-main__description" *ngIf="!item.archived">{{ item.description }}</span>
      <span class="text-main__archived" *ngIf="item.archived">{{ item.archivedText }}</span>
    </span>
  </div>
  <div class="tree-item__action">
    <mat-checkbox
      *ngIf="item.action.type === 'checkbox'"
      color="primary"
      [checked]="item.action.checked"
      [disabled]="item.action.disabled"
      (change)="onCheckboxChange($event)"
    ></mat-checkbox>
    <ng-container *ngIf="item.action.type === 'menu'">
      <mat-icon [matMenuTriggerFor]="matMenu">more_horiz</mat-icon>
      <mat-menu #matMenu="matMenu">
        <button
          class="button"
          mat-menu-item
          *ngFor="let button of item.action.buttons"
          (click)="button.action()"
          [disabled]="button.disabled"
        >
          <mat-icon class="button__icon" svgIcon="{{ button.icon }}">{{ button.icon }}</mat-icon>
          <span>{{ button.text }}</span>
        </button>
      </mat-menu>
    </ng-container>
  </div>
</div>
<div class="tree-item-children tree-item-children--level-{{ level + 1 }}" *ngIf="item?.children?.length">
  <div class="tree-item-children__separator"></div>
  <div class="tree-item-children__tree">
    <fc-tree-view [item]="child" [level]="level + 1" *ngFor="let child of item.children"></fc-tree-view>
  </div>
</div>
